import React from "react";
import MDBox from "@cloudpremise/portal_core/src/themes/mui/components/MDBox";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import MDButton from "@cloudpremise/portal_core/src/themes/mui/components/MDButton";
import '../styles/banner.scss';

const Banner = ({image, content}) => {
    const imageRef = React.useRef(null);
    const imageContainerRef = React.useRef(null);
    React.useEffect(() => {
        const onScroll = () => {
            if(imageRef.current === null){
                return;
            }

            // let perspectiveOrigin = 650.9;
            // let transformY = -17.2775;
            // let scaleY = 1.239;
            // let transformZ = 0.8425;
            // const scroll = window.scrollY;
            // if(scroll > 0){
            //     perspectiveOrigin = perspectiveOrigin - (scroll/10);
            //     transformY = transformY - (scroll/7);
            //     scaleY = scaleY + (scroll/10000);
            //     transformZ = transformZ + (scroll/175);
            // }
            // imageContainerRef.current.style.transform = "translate3d(0px, "+transformY+"px, 0px) scale(1, "+scaleY+")";
            // imageContainerRef.current.style.perspectiveOrigin = "50% "+perspectiveOrigin+"px";
            // imageRef.current.style.transform = "translate3d(0px, 0px, "+transformZ+"px)";            
        };
    
        // clean up code
        window.removeEventListener('scroll', onScroll);
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    });
    return (
        <MDBox
            className="main-banner-container"
        >
            <MDBox
                minHeight="100%"
                height="inherit"
                className="main-banner"
            >   
                <MDBox
                    height="100%"
                    width="100%"
                    ref={imageContainerRef}
                    className="image-container"
                >
                    <MDBox
                        height="100%"
                        width="100%"
                        ref={imageRef}
                        className="main-bg-layer"
                        sx={{
                            backgroundImage: `url(${image})`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                        }}
                    />
                </MDBox>
                {content}
            </MDBox>
        </MDBox>
    )
}

export default Banner;